import { getDeviceEventName } from '@/server-data'

export function useEventName(eventType: uui.domain.client.gps.wwgps.EventInfoType) {
  return getDeviceEventName(eventType)
}
